import {  FunctionComponent } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import { Cell, HeadCell } from "../../";
import { formatDelayField } from "../delayDisplay";

const DelaysTable: FunctionComponent<{ delays: Delay[] }> = ({ delays }) => {
  return (
    <TableContainer component={Paper} sx={{ marginBottom: "20px" }}>
      <Table aria-label="Delay Table">
        <TableHead>
          <TableRow>
            <HeadCell>
              <b>Minutes</b>
            </HeadCell>
            <HeadCell>
              <b>Reason</b>
            </HeadCell>
            <HeadCell>
              <b>Remark</b>
            </HeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {delays.map((delay) => (
            <TableRow key={delay.id}>
              <Cell>{formatDelayField(delay.minutes, "N/A")}</Cell>
              <Cell>{formatDelayField(delay.reason, "N/A")}</Cell>
              <Cell>{formatDelayField(delay.remark, "N/A")}</Cell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DelaysTable;
